import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationItem} from '../notification.model';

@Component({
    selector: 'app-notification-dialog',
    templateUrl: 'notification-dialog.component.html',
    styleUrls: ['notification-dialog.component.scss']
})
export class NotificationDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: NotificationItem,
                private dialogRef: MatDialogRef<any>) {
    }

    // 关闭对话窗口
    closeDialog() {
        this.dialogRef.close();
    }
}
